import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "upperCaseSplit" })
export class UpperCaseSplitPipe implements PipeTransform {
  public transform(word: string) {
    if (typeof word !== "string") {
      return word;
    }

    return word.replace(/(?=(?!^)[A-Z])/g, " ");
  }
}
